import { render, staticRenderFns } from "./course-settings-assets.vue?vue&type=template&id=617a32e9&"
import script from "./course-settings-assets.vue?vue&type=script&lang=ts&"
export * from "./course-settings-assets.vue?vue&type=script&lang=ts&"
import style0 from "./course-settings-assets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports